import {  getAllRoomPrices, formatPrice, parseDecimalFromString } from "../../utils/commonUtils"

// Updates all room prices in the list based on selected values on the dropdowns
export function updateRoomPrices() {
	const editionSlug = CollectionListDropDown.getValue("#workation-season-dropdown");
  const lengthOfStay = CollectionListDropDown.getValue("#length-stay-dropdown");
  //const guestCount = parseInt(CollectionListDropDown.getValue("#guest-count-dropdown"));
  const currency = document.querySelector("#rooms")?.getAttribute("data-currency") ?? "EUR";

  // Get all room items
  const allRooms = document.querySelectorAll('.room-list-item');
  
  const roomEditionPrices = editionSlug ? getAllRoomPrices(editionSlug) : []; //if no edition selected, we still want to loop and hide prices
  allRooms.forEach((room) => {
    const roomSlug = room.getAttribute('data-roomslug');
    const allowWeeklyBooking = room.getAttribute('data-allow-weekly-booking') === "Enabled";
    const roomEditionPrice = roomEditionPrices.find((x) => x.roomSlug === roomSlug);
    updateRoomPrice(room, roomEditionPrice, lengthOfStay, currency, allowWeeklyBooking);
  });
}

// Updates the price of one room
function updateRoomPrice(room, roomEditionPrice, lengthOfStay, currency, allowWeeklyBooking) {
  const priceBreakdownElem = room.querySelector('.room-item-price-breakdown');
  const priceMonthElem = room.querySelector('.room-item-price-month');
  const roomDiscountElem = room.querySelector('.room-discount-text');
  const roomBookButton = room.querySelector('.room-book-button');
  const noPriceAvailable = room.querySelector('.room-item-price-not-avalable');
  const isWeekBooking = lengthOfStay && lengthOfStay.startsWith("week");

  const noPriceAvailableText = noPriceAvailable.innerText;
  const weeklyBookingText = "Minimum length of stay for this room is 1 month";

  const basePriceWeek = parseDecimalFromString(roomEditionPrice?.basePriceWeek);

  // if there is no price set for the room, hide all prices and booking button
  if (!roomEditionPrice || (isWeekBooking && !allowWeeklyBooking) || (isWeekBooking && allowWeeklyBooking && !basePriceWeek)) {
    noPriceAvailable.innerText = (isWeekBooking && !allowWeeklyBooking) ? weeklyBookingText : noPriceAvailableText;
	  noPriceAvailable.style.display = 'flex';
    priceBreakdownElem.style.display = 'none';
    priceMonthElem.style.display = 'none';
    roomDiscountElem.parentElement.style.display = 'none';
    roomBookButton.style.opacity = "0.5";
    roomBookButton.style.pointerEvents = "none";
    roomBookButton.style.cursor = "not-allowed";
    return;
  }
  
  // reset all elements in case they were hidden before
  noPriceAvailable.style.display = 'none';
  priceMonthElem.style.display = 'block';
  roomDiscountElem.parentElement.style.display = 'flex';
  roomBookButton.style.opacity = "1";
  roomBookButton.style.pointerEvents = "auto";
  roomBookButton.style.cursor = "pointer";
  
  const basePriceMonth = roomEditionPrice.basePriceMonth;

  const discount2months = roomEditionPrice.discountMonth2;
  const discount3months = roomEditionPrice.discountMonth3;
  const price2Month = basePriceMonth * (1 - discount2months / 100);
  const price3Month = basePriceMonth * (1 - discount3months / 100);

  const weeklyPriceFormatted = basePriceWeek ? formatPrice(basePriceWeek, currency) : "N/A";
  const basePriceFormatted = formatPrice(basePriceMonth, currency);

  // Hide price breakdown if guest stays only 1 month or 1 week (or no length is selected), else show it
  const hidePriceBreakdown = !lengthOfStay || lengthOfStay.endsWith("-1");
  priceBreakdownElem.style.display = hidePriceBreakdown ? 'none' : 'inline';

  switch (lengthOfStay) {
    case 'week-1':
      priceMonthElem.innerText = `${weeklyPriceFormatted} / week`;
      roomDiscountElem.innerText = `Longer stays unlock better discounts!`;
      break;
    
    case 'week-2':
      priceBreakdownElem.innerText = `1st week: ${weeklyPriceFormatted}`;
      priceMonthElem.innerText = `${weeklyPriceFormatted} - 2nd week`;
      roomDiscountElem.innerText = `Longer stays unlock better discounts!`;
      break;
        
    case 'week-3':
      priceBreakdownElem.innerHTML = `
        	1st week: ${weeklyPriceFormatted}<br>
          2nd week: ${weeklyPriceFormatted}`;
      priceMonthElem.innerText = `${weeklyPriceFormatted} - 3rd week`;
      roomDiscountElem.innerText = `Longer stays unlock better discounts!`;
      break;

    default:
    case 'month-1':
      priceMonthElem.innerText = `${basePriceFormatted} / month`;
      roomDiscountElem.innerText = `Longer stays unlock better discounts!`;
      break;

    case 'month-2':
      priceBreakdownElem.innerText = `1st month: ${basePriceFormatted}`;
      priceMonthElem.innerText = `${formatPrice(price2Month, currency)} - 2nd month`;
      roomDiscountElem.parentElement.style.display =  (discount2months == 0) ? "none":  "block";
      roomDiscountElem.innerText = `${discount2months.toFixed(1)}% discount for the 2nd month!`;
      break;

    case 'month-3':
      priceBreakdownElem.innerHTML = `
        	1st month: ${basePriceFormatted}<br>
          2nd month: ${formatPrice(price2Month, currency)}`;
      priceMonthElem.innerText = `${formatPrice(price3Month, currency)} - 3rd month`;
      
      roomDiscountElem.parentElement.style.display = (discount3months == 0) ? "none":  "block";
      roomDiscountElem.innerText = `${discount3months.toFixed(1)}% discount for the 3rd month!`;
      break;
  }
}

// updates the discount elements in the length of stay dropdown
export function updateLengthOfStayDropdownDiscounts(editionSlug) {
  const months2discountElems = document.querySelectorAll('.dropdown-discount-2-months');
  const months3discountElems = document.querySelectorAll('.dropdown-discount-3-months');
  
  const roomEditionPrices = getAllRoomPrices(editionSlug);
  const discounts2months = roomEditionPrices.map((x) => x.discountMonth2);
  const discounts3months = roomEditionPrices.map((x) => x.discountMonth3);
  
  //need to be forEach because if an item is selected there are 2 (selected one and in dropdown)
  months2discountElems.forEach((elem) => {
  	updateLengthOfStayDropdownDiscount(elem, discounts2months);
  });
  months3discountElems.forEach((elem) => {
  	updateLengthOfStayDropdownDiscount(elem, discounts3months);
  });
}

// updates a single discount element in the length of stay dropdown
function updateLengthOfStayDropdownDiscount(elem, discounts) {
	if (!discounts || discounts.length === 0) {
  	elem.style.display = 'none';
    return;
  }
  elem.style.display = 'flex'; // reset previous hide

  const allEqual = discounts.every(val => val === discounts[0]);
  const highestDiscount = Math.max(...discounts);
  if (highestDiscount ==  0) {
  	elem.innerText = ``;
  } else {
  	elem.innerText = `${highestDiscount.toFixed(1)}% discount`;
  }
  if (!allEqual) {
    elem.innerText = 'Up to ' + elem.innerText;
  }
}

// loop through all rooms and update the booking URLs accoring to the filter values
export function updateAllRoomBookingButtonsUrls() {
	const allBookingButtons = document.querySelectorAll(".room-book-button");
  const destinationSlug = document.querySelector("#rooms")?.getAttribute("data-destination-slug");
  
  allBookingButtons.forEach((bookingButton) => {
  	const bookingLinkElem = bookingButton.querySelector("a");
    const baseUrl = bookingLinkElem.getAttribute("href").split("?")[0]; // Remove existing query params

		const roomSlug = bookingButton.getAttribute("data-roomslug");
    const editionSlug = CollectionListDropDown.getValue("#workation-season-dropdown");
	  const guestsCount = CollectionListDropDown.getValue("#guest-count-dropdown") ?? 1;

    // Update the link's href with the new query parameters
    bookingLinkElem.setAttribute("href", `${baseUrl}` +
      	`?destination=${encodeURIComponent(destinationSlug)}` +
      	`&edition=${encodeURIComponent(editionSlug)}` +
        `&room=${encodeURIComponent(roomSlug)}` +
        `&guests=${encodeURIComponent(guestsCount)}`);
  });
}

// set initial value of the workation season dropdown
export function setInitialWorkationSeasonDropdownItem() {
	const editionSlugQueryParam = new URLSearchParams(window.location.search).get("edition");
	const workationSeasonItems = document.querySelectorAll("#workation-season-dropdown .dropdown-item");
	const workationInitialValue = editionSlugQueryParam ?? (workationSeasonItems.length > 0 ? workationSeasonItems[0].getAttribute('data-value') : null);
	CollectionListDropDown.setValue("#workation-season-dropdown", workationInitialValue);
}
